<template>
  <span class="table-data-reference"
    >{{ value.name }}
    <ButtonComponent
      v-if="value.ref"
      tag="router-link"
      :to="{ name: 'residential-edit', params: { id: $path('ref', value), step: 'basis' } }"
      :icon="['fal', 'external-link']"
    />
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss">
.table-data-reference {
  .elder-button__icon {
    padding: 0 0.25rem !important;
    svg {
      width: 0.75em;
    }
  }
}
</style>
